module.exports = __webpack_public_path__ + "media/images/pic/brodno/lektorzy-ee9abcdb23065433a8a6e1267f9cf33e.png";